<template>
  <div class="middle cadfm-flexitem-stretched">

    <action-panel>
      <action-bar >
        <b-navbar-nav >
          <!--<action-button  @click="details"  icon="analytics-graph-bar" text="Details" title="Tooltip1" :disabled="detailsButtonStatus"/>-->
          <action-button  @click="back" icon="back" bold :text="lang.button_Back" :tooltip="lang.button_Back" :disabled="false"/>
          <action-button v-if="currentUser.role != 'Reader'"  @click="derive"  icon="derive" bold :text="lang.button_Derive" :title="lang.button_Derive" :disabled="deriveButtonStatus"/>
          <action-button  v-if="currentUser.role != 'Reader'" @click="alternative"  icon="assign-part" bold :text="lang.button_Alternative" :title="lang.button_Alternative" :disabled="alternativeButtonStatus"/>
          <action-button  v-if="currentUser.role != 'Reader'" @click="addPhysical"  icon="add-physical" bold :text="lang.button_AddPhysical"
            :title="lang.button_AddPhysical" :disabled="addPhysicalButtonStatus"/>  
          <action-button v-if="tabStatus==1 && currentUser.role != 'Reader'" @click="editPhysical" icon="edit" bold :text="lang.button_EditPhysical"
            :title="lang.button_EditPhysical" :disabled="editPhysicalButtonStatus" />
          <action-button v-if="tabStatus==1 && currentUser.role != 'Reader'" @click="deletePhysical" icon="remove" bold :text="lang.button_DeletePhysical" :title="lang.button_DeletePhysical" :disabled="deletePhysicalButtonStatus" />
 
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold text="Show panel left" title="You can display left panel!" :disabled="toggleButtonStatus"/>
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold text="Show panel right" title="You can display right panel!" :disabled="toggleButtonStatus"/>

        </b-navbar-nav>

      </action-bar>

      <action-content>
        <Content  :lang="lang.Content"></Content>
      </action-content>
    </action-panel>

 </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ActionBar from '@/components/shared/ActionBar'
import ActionButton from '@/components/shared/ActionButton'
import ActionContent from '@/components/shared/ActionContent'
import ActionPanel from '@/components/shared/ActionPanel'
import TitleComponent from "@/components/shared/TitleComponent"
import Content from "@/components/PartManager/Views/PartSearch/Middle/Content/Content"

export default {
  name: 'Middle',
  components: {
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    TitleComponent,
    Content
  },
  props:{
    
    lang: Object
  },
  data () {
    return {
      //title: "Parts",
      detailsButtonStatus: true,
      deriveButtonStatus: true,
      editPhysicalButtonStatus: true,
      deletePhysicalButtonStatus: true,
      alternativeButtonStatus: true,
      addPhysicalButtonStatus: false,
      toggleButtonStatus: false,
      toggleRightPanelIcon: 'view',
      pathToForBack: this.$route.query.from,
      tabStatus: 0
    }
  },
  created(){
    //setTimeout(this.changeIcon,5000)
  },
  computed: {
    ...mapGetters({

      //selectedRowsSearch: 'selectedRowsSearch',
      selectedSearchedRows: 'selectedSearchedRows',
      alternativePartsToBind: 'alternativePartsToBind',
      currentUser: 'currentUser'



    }),
  },
  watch: {
    alternativePartsToBind: function (newVal) {
      
      if (newVal.length != 0 && this.$route.query.revisionId != ""){
        this.alternativeButtonStatus = false
      }else{
        this.alternativeButtonStatus = true
      }
    },
    selectedSearchedRows: function () {


      //for derive button
      if (this.selectedSearchedRows.DistributorPartId != undefined){
        this.deriveButtonStatus = false

      }else{
         this.deriveButtonStatus = true
      }
      //for edit button
      if (this.selectedSearchedRows.DistributorPartId != undefined) {
        this.editPhysicalButtonStatus = false

      } else {
        this.editPhysicalButtonStatus = true
      }
      //for delete button
      if (this.selectedSearchedRows.DistributorPartId != undefined) {
        this.deletePhysicalButtonStatus = false

      } else {
        this.deletePhysicalButtonStatus = true
      }

    }
  },
  methods: {
    switchButtons(index) {

      this.tabStatus = index;
    },
    back(){
      
      const reloadObj = {
          status: true,
          name: "DataTableFilteredOnApiComponent"
      }
      this.$store.dispatch("reloadAfterAction", reloadObj);

      let to = this.$route.query.from;
      let from = "";

      if (Object.keys(this.$route.query).length == 0){

        to = "/PartManager/PartTable";
        from = "/PartManager/PartSearch";

       

        
        const query = {
          from: this.$route.path,
          to: to,
          end: true
          
        }

        this.$router.push({ path: to, query: query }); 

      }

      
      
      const query = {
        from: this.$route.path,
        to: to,
        end: true,
        revisionId: this.$route.query.revisionId,
        id: this.$route.query.id
      }

      this.$router.push({ path: to, query: query });
    },
    derive(){
      
      let to = "/PartManager/PartDerive";

     

      
      const query = {
        from: this.$route.path,
        to: to,
        key: this.selectedSearchedRows.DistributorPartId,
        source: "PartSearch"
      }

      this.$router.push({ path: to, query: query });
    },
    alternative(){
      
      
      let vue = this;
      if (this.$store.getters.selectedRows.length != 1){
        let objAlert = {
          title: this.lang.alert_Title,
          text: this.lang.alert_Text + "\n\r ",
          text2: "",
          type: "info",
          buttons: 1,
          size: "sm",
          funcOk: ""
        }

        this.$store.dispatch("showAlert", objAlert);
        return
      }
      let obj = {
        partId: this.$store.getters.selectedRows[0].col___revisionId.partId,
        alternatives: this.$store.getters.alternativePartsToBind
      }
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_assignPhysicals", obj)
      .then((result) => {

        console.log(result)
        if (result.status == "OK"){
          //alert
          if (result.data == 1){

            const obj = {
              text: vue.lang.alert_success_setAlternative,
              time: 5,
              type: "success"
            }

            vue.$store.dispatch("displayFooterAlert", obj);

            
          }else{
            const obj = {
              text: vue.lang.alert_error_setAlternative,
              time: 5,
              type: "danger"
            }

            vue.$store.dispatch("displayFooterAlert", obj);
          }


        }
      })
    },
    addPhysical() {

      let to = "/PartManager/PartPhysicals";
      

      
      const query = {
        from: this.$route.path,
        to: to,
        source: "new"
      }

      this.$router.push({ path: to, query: query });
    },
    editPhysical() {
      let to = "/PartManager/PartPhysicals";



      const query = {
        from: this.$route.path,
        to: to,
        source: "update",
        distributorPartId: this.selectedSearchedRows.DistributorPartId
      }

      this.$router.push({ path: to, query: query });
    },
    deletePhysical() {
      let vue = this;

      let deleteFunc = function () {
        let obj = {};
        const objS = {
          distributorId: vue.selectedSearchedRows.DistributorPartId
        }

        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_deletePhysical", objS)
          .then((result) => {

            console.log(result)
            
            if (result.status == "OK") {

              if (result.data != null) {
                obj = {
                  text: vue.lang.alert_success_deletePhysicalPart,
                  time: 10,
                  type: "success"
                }
                
                const reloadObj = {
                  status: true,
                  name: "PhysicalHandmadePartsTableComponent"
                }
                vue.$store.dispatch("reloadAfterAction", reloadObj);

              } else {
                obj = {
                  text: vue.lang.alert_error_deletePhysicalPart + ". ",
                  time: 15,
                  type: "danger"
                }

              }
            } else {
              obj = {
                text: vue.lang.alert_error_deletePhysicalPart + ": " + result.message,
                time: 15,
                type: "danger"
              }

            }
            vue.$store.dispatch("displayFooterAlert", obj);
          })
      }

      const obj = {
        title: vue.lang.modal_title_DeletePhysical,
        text: this.lang.alerttitle_DeletePhysical,
        type: "sure",
        buttons: 2,
        size: "sm",
        funcYes: deleteFunc,
        funcNo: ""
      };

      this.$store.dispatch("showAlert", obj);
    },
    toggleRightPanel(){
      
      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;
      
    },
    toggleLeftPanel(){
      
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
      
    }


  },
  
}
</script>


<style scoped>

  .middle{
    border-right: 1px solid #666;
    width: 30%;
  }
</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartSearch/Middle/Middle.vue